import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule, DialogModule, TooltipModule } from 'primeng/primeng';

import { NecAlert } from './alert/alert.service';
import { NecAuthService } from './auth/auth.service';
import { NecCacheService } from './cache/cache.service';
// import { NecCategoryConfigInterface } from './category/category-config.interface';
// import { NecCategoryInterface } from './category/category.interface';
// import { NecCategoryService } from './category/category.service';
import { NecDictDataService } from './dict-data/dict-data.service';
import { NecErrorCollectService } from './error-collect/error-collect.service';
import { NecFolderTreeService } from './folder-tree/nec-folder-tree.service';
import { NecHealthInterface } from './health/health.interface';
import { NecDefaultLearnCertConfigInterface } from './learncert/default-learn-cert-config.interface';
import { NecLocalStorageService } from './localStorage/local-storage.service';
import { NecModalComponent } from './modal/modal.component';
import { NecModalService } from './modal/modal.service';
import { NgBoxModule } from './ngbox/ngbox.module';
import { NgBoxService } from './ngbox/ngbox.service';
import { NecOssInterface } from './oss/oss.interface';
import { NecOssService } from './oss/oss.service';
import { NecRouterDataService } from './router-data/router-data.service';
import { NecSheetService } from './sheet/sheet.service';
import { NecDeptInterface } from './tenant/dept.interface';
import { NecDeptService } from './tenant/dept.service';
import { NecTenantInterface } from './tenant/tenant.interface';
import { NecTenantService } from './tenant/tenant.service';
import { NecGrowlComponent } from './toast/growl';
import { MessageService } from './toast/message.service';
import { NecToast } from './toast/toast.service';
import { UserInterface } from './user/user.interface';
import { UserService } from './user/user.service';

@NgModule({
  imports: [CommonModule, TooltipModule, ConfirmDialogModule, DialogModule, HttpClientModule, NgBoxModule],
  exports: [ConfirmDialogModule, HttpClientModule, DialogModule, NecGrowlComponent, NecModalComponent, NgBoxModule],
  declarations: [NecGrowlComponent, NecModalComponent],
  providers: [
    NecErrorCollectService,
    NecHealthInterface,
    ConfirmationService,
    MessageService,
    NecAlert,
    NecAuthService,
    NecCacheService,
    // NecCategoryService,
    // NecCategoryInterface,
    // NecCategoryConfigInterface,
    NecLocalStorageService,
    NecDictDataService,
    NecModalService,
    NecRouterDataService,
    NecOssService,
    NecOssInterface,
    NecToast,
    NgBoxService,
    NecSheetService,
    NecDefaultLearnCertConfigInterface,
    UserInterface,
    UserService,
    NecDeptService,
    NecDeptInterface,
    NecTenantInterface,
    NecTenantService,
    NecFolderTreeService
  ]
})
export class NecCommonServiceModule {}
